
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      defaultMsg: '<b>收费策略</b>',
      searchInput: '',
      tableList: [],
      moduleId: 7,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogHandle: false,
      version_name: '',
      err_vn: '',
      status: '',
      err_s: '',
      remark: '',
      strategyDetail: {},
      dialogDetail: false,
      tabType: 0,
      featureData: {},
      dialogStatus: false,
      dialogDelete: false,
      dialogfeature: false,
      userData: [],
      pageSize2: 20,
      pageNum2: 1,
      tableTotal2: 0,
      dialogCusDetail: false,
      customerData: {},
      defaultFun: [8, 9],
      logList: [],
      sort: '',
      err_sort: '',
      unit_price: '',
      err_up: '',
      user_count: '',
      err_uc: '',
      description: '',
      err_desc: '',
      dialog: false
    }
  },
  mounted () {
    this.queryChargingStrategyList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 功能清单-实时
    this.$bus.off('feature-edit')
    this.$bus.on('feature-edit', value => {
      console.log('feature-edit', value)
      this.featureEdit = value
    })
    // 关闭详情窗口
    this.$bus.on('closeDetailModal', (value) => {
      console.log(value)
      if (value) {
        this.dialogCusDetail = false
      }
    })
    // 关闭试用详情窗口
    this.$bus.on('close-trial-detail', (value) => {
      console.log(value)
      if (value) {
        this.dialogCusDetail = false
      }
    })
    // 更新消费策略的客户列表 - 试用
    this.$bus.off('query-trial-list')
    this.$bus.on('query-trial-list', (value, page) => {
      console.log(value)
      if (value) {
        if (page) {
          this.pageNum2 = 1
        }
        this.queryFormalUserListByCSID()
      }
    })
    // 更新消费策略的客户列表 - 正式
    this.$bus.off('query-formal-list')
    this.$bus.on('query-formal-list', (value, page) => {
      console.log(value)
      if (value) {
        if (page) {
          this.pageNum2 = 1
        }
        this.queryFormalUserListByCSID()
      }
    })
    // 更新收费策略列表
    this.$bus.off('query-strategy-list')
    this.$bus.on('query-strategy-list', (value, page) => {
      console.log(value)
      if (value) {
        this.queryChargingStrategyList()
      }
    })
  },
  methods: {
    /** 获取列表 */
    queryChargingStrategyList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryChargingStrategyList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryChargingStrategyList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryChargingStrategyList()
    },
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryChargingStrategyList()
    },
    /** 新增客户弹窗 */
    AddDialog () {
      HTTPServer.getDefaultCommodityList({}, 'Loading').then((res) => {
        console.log('AddDialog', res)
        res.map((item) => {
          item.funcList.map((fun) => {
            fun.choice = '0'
            if (this.defaultFun.includes(fun.id)) {
              fun.choice = '1'
              fun.disabled = true
            }
          })
        })
        this.featureData = {'data': res, 'type': 2}
        this.dialogHandle = true
        this.version_name = ''
        this.status = '0'
        this.remark = ''
        this.err_vn = ''
        this.err_s = ''
        this.err_sort = ''
        this.err_up = ''
        this.err_uc = ''
        this.err_desc = ''
      })
    },
    /** 保存验证 */
    saveInit () {
      this.err_vn = ''
      this.err_s = ''
      this.err_sort = ''
      this.err_up = ''
      this.err_uc = ''
      this.err_desc = ''
      let reg = /^[1-9]\d*$/
      if (!this.version_name) {
        this.err_vn = '版本名称不能为空'
        return
      }
      if (!this.status) {
        this.err_s = '版本状态不能为空'
        return false
      }

      if (this.sort && !reg.test(this.sort)) {
        this.err_sort = '格式错误'
        return false
      }
      if (!this.unit_price) {
        this.err_up = '版本单价不能为空'
        return false
      }
      if (!reg.test(this.unit_price)) {
        this.err_up = '格式错误'
        return false
      }
      if (!this.user_count) {
        this.err_uc = '适用人数不能为空'
        return false
      }
      if (!reg.test(this.user_count)) {
        this.err_uc = '格式错误'
        return false
      }
      if (!this.description) {
        this.err_desc = '版本说明不能为空'
        return false
      }
      return true
    },
    /** 收费策略 （新增、编辑） */
    dialogSave () {
      var b = this.saveInit()
      if (!b) {
        return
      }
      let arr = []
      if (!this.dialogDetail) arr = this.featureInit(this.featureEdit)
      var jsondata = {
        'version_name': this.version_name,
        'status': this.status,
        'sort': this.sort,
        'unit_price': this.unit_price,
        'user_count': this.user_count,
        'description': this.description,
        'remark': this.remark,
        'moduleAuth': arr
      }
      console.log(jsondata)
      if (this.dialogDetail) {
        jsondata.id = this.strategyDetail.id
        delete jsondata.moduleAuth
        HTTPServer.editChargingStrategy(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.err_vn = ''
          this.err_s = ''
          this.err_sort = ''
          this.err_up = ''
          this.err_uc = ''
          this.err_desc = ''
          this.strategyDetail.version_name = jsondata.version_name
          this.strategyDetail.status = jsondata.status
          this.strategyDetail.remark = jsondata.remark

          this.strategyDetail.sort = jsondata.sort
          this.strategyDetail.unit_price = jsondata.unit_price
          this.strategyDetail.user_count = jsondata.user_count
          this.strategyDetail.description = jsondata.description
          this.dialogHandle = false
          this.queryChargingStrategyList()
        })
      } else {
        HTTPServer.saveChargingStrategy(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogHandle = false
          this.queryChargingStrategyList()
        })
      }
    },
    /** 收费策略 编辑弹窗 */
    editDialog () {
      this.queryVersionCommodityByVersion(2)
    },
    /** 收费策略 - 获取功能清单 */
    queryVersionCommodityByVersion (type) {
      HTTPServer.queryVersionCommodityByVersion({'strategyId': this.strategyDetail.id}, 'Loading').then((res) => {
        res.map((item) => {
          item.funcList.map((fun) => {
            if (this.defaultFun.includes(fun.id)) {
              fun.choice = '1'
              fun.disabled = true
            }
          })
        })
        this.featureData = {'data': res, 'type': type}
        // this.featureData = Object.assign({}, this.featureData, {'data': res, 'type': type})
        if (type === 2) {
          this.dialogHandle = true
          this.version_name = this.strategyDetail.version_name
          this.status = this.strategyDetail.status
          this.sort = this.strategyDetail.sort
          this.unit_price = this.strategyDetail.unit_price
          this.user_count = this.strategyDetail.user_count
          this.description = this.strategyDetail.description
          this.remark = this.strategyDetail.remark
        }
      })
    },
    /** 进入收费策略详情 */
    rowClick (row, event, column) {
      console.log(row, event, column)
      this.tabType = 0
      this.activeNames = ['1', '2']
      this.strategyDetail = row
      this.dialogDetail = true
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      console.log('click on item ' + command)
      if (command === '1') {
        this.dialogStatus = true
      } else if (command === '2') {
        this.dialogDelete = true
      }
    },
    /** 删除收费策略 */
    strategyDelete (id) {
      var jsondata = {'id': this.strategyDetail.id}
      HTTPServer.delChargingStrategy(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.pageNum = 1
        this.searchValue = ''
        this.dialogDetail = false
        this.queryChargingStrategyList()
      })
    },
    /** 禁用/启用收费策略 */
    strategyStatus () {
      var jsondata = {id: this.strategyDetail.id, status: (this.strategyDetail.status === '0') ? '1' : '0'}
      HTTPServer.enableDisableChargingStrategy(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.strategyDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.strategyDetail.modify_time = (new Date()).getTime()
        this.dialogStatus = false
        this.strategyDetail.status = jsondata.status
        this.queryChargingStrategyList()
      })
    },
    /** 详情导航切换 */
    dtlChange (type) {
      if (type === 1) {
        this.queryVersionCommodityByVersion(1)
      } else if (type === 2) {
        this.queryAllChargingStrategy()
        this.queryFormalUserListByCSID()
      } else if (type === 3) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.strategyDetail.id})
      }
      this.tabType = type
    },
    /** 修改收费策略的功能清单(弹窗) */
    editFeature () {
      this.dialogfeature = true
    },
    /** 修改收费策略的功能清单 */
    savefeature () {
      let arr = this.featureInit(this.featureEdit)
      var jsondata = {'strategy_id': this.strategyDetail.id, 'moduleAuth': arr}
      console.log(jsondata)
      HTTPServer.saveCommodityByVersion(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogfeature = false
        this.queryVersionCommodityByVersion(1)
      })
    },
    /** 获取消费策略的客户列表 */
    queryFormalUserListByCSID () {
      this.userData = []
      var jsondata = {'strategy_id': this.strategyDetail.id, 'pageSize': this.pageSize2, 'pageNum': this.pageNum2}
      HTTPServer.queryFormalUserListByCSID(jsondata, 'Loading').then((res) => {
        this.userData = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal2 = pageInfo.totalRows
        if (this.dialogCusDetail) {
          this.userData.map((item) => {
            if (this.customerData.id === item.id) {
              this.customerData = Object.assign({}, this.customerData, item)
            }
          })
        }
      })
    },
    /** 显示每页条数 */
    handleSizeChange2 (val) {
      this.pageSize2 = val
      this.pageNum2 = 1
      this.queryFormalUserListByCSID()
    },
    /** 跳转第几页 */
    handleCurrentChange2 (val) {
      this.pageNum2 = val
      this.queryFormalUserListByCSID()
    },
    /** 客户列表 - 行点击 */
    userClick (row, event, column) {
      console.log(row, event, column)
      this.customerData = row
      this.dialogCusDetail = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/controller/strategy.js